function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Close as CloseIcon } from '@mui/icons-material';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, FormControl, InputLabel, Select, MenuItem, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { constants } from '../constants';
import { ConfigContext } from './ConfigContext';
var UserGroupModal = function UserGroupModal(_ref) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var open = _ref.open, onClose = _ref.onClose, onSave = _ref.onSave, group = _ref.group, loading = _ref.loading, applications = _ref.applications, _ref$roles = _ref.roles, roles = _ref$roles === void 0 ? [] : _ref$roles;
    var _useState = useState(''), _useState2 = _slicedToArray(_useState, 2), groupName = _useState2[0], setGroupName = _useState2[1];
    // Removed selectedApplication state
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), selectedRoles = _useState4[0], setSelectedRoles = _useState4[1];
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), error = _useState6[0], setError = _useState6[1];
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var isEditMode = !!group; // Edit mode when group is provided
    useEffect(function () {
        if (open) {
            if (group) {
                var _group$details;
                // Edit mode - populate form with existing data
                setGroupName(group.name || '');
                // Parse role IDs from group details
                var roleIds = ((_group$details = group.details) === null || _group$details === void 0 || (_group$details = _group$details.roles) === null || _group$details === void 0 ? void 0 : _group$details.map(Number)) || [];
                setSelectedRoles(roleIds);
            }
            else {
                // Add mode - reset form
                setGroupName('');
                setSelectedRoles([]);
            }
            setError(null);
        }
    }, [open, group]);
    var handleSave = function handleSave() {
        if (groupName.trim() && selectedRoles.length > 0) {
            var groupData = {
                name: groupName.trim(),
                roleIds: selectedRoles
            };
            onSave(groupData);
        }
    };
    var handleRoleChange = function handleRoleChange(event) {
        var value = event.target.value;
        setSelectedRoles(typeof value === 'string' ? [] : value);
    };
    var handleDeleteRole = function handleDeleteRole(roleId) {
        setSelectedRoles(selectedRoles.filter(function (id) {
            return id !== roleId;
        }));
    };
    var canSave = groupName.trim() && selectedRoles.length > 0;
    var getButtonText = function getButtonText() {
        if (loading)
            return constants.saving;
        return isEditMode ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: 2,
                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                minHeight: 400
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        variant: "h6",
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, isEditMode ? constants.usergroup_modal_title_edit((_configState$settings = configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.workspace_name) !== null && _configState$settings !== void 0 ? _configState$settings : constants.workspace_default_name) : constants.usergroup_modal_title_add((_configState$settings3 = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.workspace_name) !== null && _configState$settings3 !== void 0 ? _configState$settings3 : constants.workspace_default_name)), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            p: '24px !important'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        label: constants.usergroup_modal_field_group_name,
        value: groupName,
        onChange: function onChange(e) {
            return setGroupName(e.target.value);
        },
        required: true
    }), /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        size: "small"
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        id: "role-select-label"
    }, constants.usergroup_modal_field_roles), /*#__PURE__*/ React.createElement(Select, {
        labelId: "role-select-label",
        multiple: true,
        value: selectedRoles,
        onChange: handleRoleChange,
        label: constants.usergroup_modal_field_roles,
        renderValue: function renderValue() {
            return constants.usergroup_modal_select;
        }
    }, roles.map(function (role) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: role.id,
            value: Number(role.id)
        }, role.name);
    }))), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mt: 1
        }
    }, error), selectedRoles.length > 0 && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1
        }
    }, selectedRoles.map(function (roleId) {
        var role = roles.find(function (r) {
            return Number(r.id) === Number(roleId);
        });
        return role ? /*#__PURE__*/ React.createElement(Chip, {
            key: roleId,
            label: role.name,
            onDelete: function onDelete() {
                return handleDeleteRole(roleId);
            },
            deleteIcon: /*#__PURE__*/ React.createElement(CloseIcon, null),
            sx: {
                backgroundColor: '#f3f8eb',
                color: '#1a5d09',
                fontSize: 12,
                fontWeight: 600,
                height: 24,
                '& .MuiChip-deleteIcon': {
                    color: '#1a5d09',
                    fontSize: 16,
                    '&:hover': {
                        color: '#26890d'
                    }
                }
            }
        }) : null;
    })))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            px: 3,
            pb: 2,
            pt: 1,
            gap: 2,
            borderTop: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        disabled: loading,
        sx: {
            color: '#26890d',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 2,
            py: 1,
            '&:hover': {
                backgroundColor: 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: loading || !canSave,
        sx: {
            backgroundColor: canSave ? '#26890d' : '#e0e0e0',
            color: canSave ? '#ffffff' : '#999',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 3,
            py: 1,
            '&:hover': {
                backgroundColor: canSave ? '#1f6b0a' : '#e0e0e0'
            },
            '&:disabled': {
                backgroundColor: '#e0e0e0',
                color: '#999'
            }
        }
    }, getButtonText())));
};
export default UserGroupModal;
